<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-title color="white">Dettaglio ticket</ion-title>
                <ion-buttons slot="start">
                    <ion-button @click="closeModal()">
                        <ion-icon slot="start" :icon="arrowBackOutline" color="white"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <div class="page_content">
                <!-- Img modal, triggered with click on ticket attachment -->
                <Transition name="fade-transition">
                    <div v-show="showImgModal" class="attachment_modal">
                        <div class="customers_container">
                            <img :src="selectedImage" alt="Allegato ticket" />
                        </div>
                        <div @click="closeAttachmentModal()" class="close_modal">Chiudi</div>
                    </div>
                </Transition>

                <!-- Ticket -->
                <div class="richiesta">
                    <div v-if="ticket.tickets_subject" class="field">
                        <div class="title ticket_title">
                            {{ ticket.tickets_subject ? ticket.tickets_subject : "-" }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Data apertura</div>
                        <div class="value">
                            {{ ticket.tickets_creation_date ? dateFormat(ticket.tickets_creation_date) : "-" }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Progetto</div>
                        <div class="value">
                            {{ ticket.projects_name ? ticket.projects_name : "-" }}
                        </div>
                    </div>
                    <div class="field address_field" v-if="setAddress(ticket).length != 0">
                        <div class="title">Indirizzo</div>
                        <div class="value">
                            {{ setAddress(ticket) }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Cliente</div>
                        <div class="value">
                            {{ setShortCustomer(ticket.customers_company) }}
                        </div>
                    </div>
                    <div class="field" v-if="ticket.tickets_contact">
                        <div class="title">Contatto</div>
                        <div class="value">
                            <span v-if="telefonoCliente(ticket)">
                                <a :href="`tel:${telefonoCliente(ticket)}`" class="mobile_link">{{ contattoCliente(ticket) }}</a>
                            </span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Telefono</div>
                        <div class="value">
                            <span v-if="ticket.customers_phone">
                                <a :href="`tel:${ticket.customers_phone}`" class="mobile_link">{{ ticket.customers_phone }}</a>
                            </span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Categoria</div>
                        <div class="value">
                            {{ ticket.tickets_category_value ? ticket.tickets_category_value : "-" }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Priorità</div>
                        <div class="badge" :class="prioritaTicket(ticket.tickets_priority)">
                            {{ ticket.tickets_priority_value ? ticket.tickets_priority_value : "-" }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Stato</div>
                        <div class="badge" :class="statoTicket(ticket.tickets_status)">
                            {{ ticket.tickets_status_value ? ticket.tickets_status_value : "-" }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Creato da</div>
                        <div class="value">
                            {{ ticket.users_first_name && ticket.users_last_name ? `${ticket.users_first_name} ${ticket.users_last_name}` : "-" }}
                        </div>
                    </div>
                    <div v-if="ticketAttachments.length" class="field_allegati">
                        <div class="title">Allegati</div>
                        <div class="allegati_container">
                            <div
                                v-for="(attachment, index) in ticketAttachments"
                                :key="index"
                                class="attachment_card"
                                :class="{ image_attachment: isImageAttachment(attachment) }"
                            >
                                <button v-if="isImageAttachment(attachment)" type="button" class="attachment_preview" @click="openImgDetail(attachment)">
                                    <img :src="setAttachmentUrl(attachment)" :alt="getAttachmentName(attachment, index)" />
                                </button>
                                <a v-else :href="setAttachmentUrl(attachment)" target="_blank" rel="noopener noreferrer" class="attachment_preview">
                                    <ion-icon :icon="getAttachmentIcon(attachment)"></ion-icon>
                                    <span class="attachment_name">{{ getAttachmentName(attachment, index) }}</span>
                                    <span class="attachment_type">{{ getAttachmentTypeLabel(attachment) }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="field_note">
                        <div class="title">Descrizione</div>
                        <div class="value">
                            {{ parseHtmlEnteties(ticket.tickets_message) }}
                        </div>
                    </div>
                </div>

                <div v-if="messages.length > 0" class="messages">
                    <div class="title">
                        Messaggi
                    </div>
                    <div class="messages_container">
                        <div
                            v-for="message in messages"
                            :key="message.tickets_messages_id"
                            class="message_content"
                            :class="[message.tickets_messages_member == loggeUserId ? 'user_message' : 'customer_message']"
                        >
                            <div>
                                {{ message.tickets_messages_text }}
                            </div>
                            <div class="date">
                                {{ dateFormatWithMinutes(message.tickets_messages_creation_date) }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="ticket.tickets_status && ticket.tickets_status != 5" class="nuovo_intervento">
                    <div class="intervento_button" @click="openNuovoIntervento">
                        Crea intervento
                    </div>
                </div>

                <div class="interventi_container">
                    <div class="interventi_label">Interventi</div>
                    <div v-if="loading" class="loading_spinner">
                        <ion-spinner name="crescent" color="dark"></ion-spinner>
                    </div>
                    <div v-else>
                        <div v-if="interventi.length == 0">
                            <div class="no_interventi_container">
                                <div class="no_interventi">
                                    Nessun intervento da visualizzare
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div
                                v-for="intervento in interventi"
                                :key="intervento.tickets_reports_id"
                                class="intervento"
                                @click="openInterventoDetail(intervento)"
                            >
                                <div class="date">
                                    {{ dateFormat(intervento.tickets_reports_date) }},
                                    {{ intervento.tickets_reports_start_time + " - " + intervento.tickets_reports_end_time }}
                                </div>
                                <div class="badge" :class="statusIntervento(intervento.tickets_reports_stato_lavori_chiudi_ticket)">
                                    {{ intervento.tickets_reports_stato_lavori_value }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    //IonBackButton,
    IonTitle,
    IonContent,
    IonIcon,
    IonButton,
    IonSpinner,
    modalController,
} from "@ionic/vue";
import {
    arrowBackOutline,
    archiveOutline,
    documentOutline,
    documentTextOutline,
    gridOutline,
    imageOutline,
    musicalNotesOutline,
    videocamOutline,
} from "ionicons/icons";

import { defineComponent, onMounted, ref, computed } from "vue";

import { LOCALSTORAGE_KEY } from "@/custom_config";

import { checkField, dateFormat, dateFormatWithMinutes } from "@/services/utils";
import { openToast } from "@/services/toast";
import interventiAPI from "@/services/interventi";
import ticketsAPI from "@/services/tickets";

import ModalNuovoInterventoFromTicket from "@/components/ticket/ModalNuovoInterventoFromTicket";
import InterventoDetail from "@/components/interventi/InterventoDetail";

export default defineComponent({
    name: "TicketDetail",
    props: {
        data: {
            type: Object,
            required: true,
        },
        ticket_id: {
            type: String,
        },
    },
    components: {
        IonPage,
        IonHeader,
        IonToolbar,
        IonButtons,
        //IonBackButton,
        IonTitle,
        IonContent,
        IonIcon,
        IonButton,
        IonSpinner,
    },
    setup(props, context) {
        const loggeUserId = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_user_id;

        const loading = ref(false);
        const ticket = ref([]);
        const interventi = ref([]);

        /**
         * ! Get ticekt data
         * ! ONLY IF COMING FROM INTERVENTO DETAIL
         */
        /* async function loadTicketDetail(ticket_id) {
            try {
                ticket.value = await ticketsAPI.getTicketData(ticket_id);
            } catch (error) {
                console.error(error);
                openToast("Errore durante la richiesta dei dettagli del ticket", "toast_danger");
            } finally {
                console.log(ticket.value);
            }
        }

        if (props.ticket_id && typeof (props.ticket_id != "undefined")) {
            loadTicketDetail(props.ticket_id);
        } else {
            ticket.value = { ...props.data };
        } */
        ticket.value = { ...props.data };

        /**
         * ! Open modal to create new intervento
         */
        async function openNuovoIntervento() {
            const modal = await modalController.create({
                component: ModalNuovoInterventoFromTicket,
                componentProps: {
                    data: ticket,
                },
            });
            modal.onDidDismiss().then((detail) => {
                if (detail.data != undefined) {
                    interventi.value.unshift(detail.data);
                    openToast("Intervento salvato con successo", "toast_success");
                }
            });
            return modal.present();
        }

        /**
         * ! Open modal to create new intervento
         */
        async function openInterventoDetail(intervento) {
            const modal = await modalController.create({
                component: InterventoDetail,
                componentProps: {
                    data: intervento,
                },
            });
            return modal.present();
        }

        /**
         * ! Handle close modal by clicking on Chiudi button
         */
        const closeModal = () => {
            modalController.dismiss();
        };

        /**
         * ! Print projects address
         */
        function setAddress(ticket) {
            const city = ticket.projects_city ? `${ticket.projects_city}, ` : "";
            const address = ticket.projects_address ? `${ticket.projects_address} ` : "";
            const province = ticket.projects_province ? `(${ticket.projects_province})` : "";
            return `${city}${address}${province}`;
        }

        /**
         * ! Print customer reference
         */
        function contattoCliente(ticket) {
            const name = ticket.customers_contacts_name ? `${ticket.customers_contacts_name}` : "";
            const lastName = ticket.customers_contacts_last_name ? ` ${ticket.customers_contacts_last_name} ` : "";
            return `${name}${lastName}`;
        }

        /**
         * ! Print customer phone
         */
        function telefonoCliente(ticket) {
            if (ticket.customers_contacts_phone) {
                return ticket.customers_contacts_phone;
            } else if (ticket.customers_contacts_mobile_number) {
                return ticket.customers_contacts_mobile_number;
            } else {
                return "";
            }
        }

        /**
         * ! Limit customers to 35 charactes
         */
        function setShortCustomer(customer) {
            if (!customer) {
                return "-";
            } else {
                const trimmedString = customer.length > 35 ? customer.substring(0, 32) + "..." : customer;
                return trimmedString;
            }
        }

        const ticketAttachments = computed(() => {
            if (!ticket.value.tickets_attachments) {
                return [];
            }

            try {
                const attachments = JSON.parse(ticket.value.tickets_attachments);
                return Array.isArray(attachments) ? attachments.filter(Boolean) : [];
            } catch (error) {
                console.error(error);
                return [];
            }
        });

        const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];

        function setAttachmentUrl(attachment) {
            if (attachment && attachment.path_local) {
                return `${process.env.VUE_APP_BASE_URL}/uploads/${attachment.path_local}`;
            }
            return "";
        }

        function getAttachmentName(attachment, index) {
            if (!attachment) {
                return `Allegato ${index + 1}`;
            }
            if (attachment.original_filename) {
                return attachment.original_filename;
            }
            if (attachment.client_name) {
                return attachment.client_name;
            }
            if (attachment.file_name) {
                return attachment.file_name;
            }
            if (attachment.name) {
                return attachment.name;
            }
            if (attachment.path_local) {
                return attachment.path_local.split("/").pop();
            }
            return `Allegato ${index + 1}`;
        }

        function getAttachmentExtension(attachment) {
            const filename = getAttachmentName(attachment, 0);
            const extension = filename.includes(".") ? filename.split(".").pop().toLowerCase() : "";
            return extension;
        }

        function getAttachmentMime(attachment) {
            if (!attachment) {
                return "";
            }
            return (attachment.mime || attachment.file_type || attachment.type || "").toLowerCase();
        }

        function isImageAttachment(attachment) {
            const mime = getAttachmentMime(attachment);

            if (attachment && (attachment.is_image === true || attachment.is_image === "1" || mime.startsWith("image/"))) {
                return true;
            }

            return imageExtensions.includes(getAttachmentExtension(attachment));
        }

        function getAttachmentTypeLabel(attachment) {
            const extension = getAttachmentExtension(attachment);
            return extension ? extension.toUpperCase() : "FILE";
        }

        function getAttachmentIcon(attachment) {
            const mime = getAttachmentMime(attachment);
            const extension = getAttachmentExtension(attachment);

            if (mime.includes("pdf") || extension === "pdf") {
                return documentTextOutline;
            } else if (mime.includes("word") || ["doc", "docx", "rtf", "odt"].includes(extension)) {
                return documentTextOutline;
            } else if (mime.includes("excel") || mime.includes("spreadsheet") || ["xls", "xlsx", "csv", "ods"].includes(extension)) {
                return gridOutline;
            } else if (isImageAttachment(attachment)) {
                return imageOutline;
            } else if (mime.startsWith("video/") || ["mp4", "mov", "avi", "mkv"].includes(extension)) {
                return videocamOutline;
            } else if (mime.startsWith("audio/") || ["mp3", "wav", "ogg", "m4a"].includes(extension)) {
                return musicalNotesOutline;
            } else if (["zip", "rar", "7z", "tar", "gz"].includes(extension)) {
                return archiveOutline;
            }

            return documentOutline;
        }

        /**
         * Remove html tag from ticket description
         */
        function parseHtmlEnteties(str) {
            if (str) {
                const strippedString = str.replace(/(<([^>]+)>)/gi, "");
                return strippedString.replace(/&#([0-9]{1,3});/gi, function(match, numStr) {
                    const num = parseInt(numStr, 10); // read num as normal number
                    return String.fromCharCode(num);
                });
            } else {
                return "-";
            }
        }

        //Set correct background for ticket status
        const statoTicket = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == 1) {
                    //ticket aperti
                    className = "badge_open";
                } else if (statusId == 2) {
                    //ticket in lavorazione
                    className = "badge_working";
                } else if (statusId == 3) {
                    //ticket attesa risposta
                    className = "badge_waiting_answer";
                } else if (statusId == 4) {
                    //ticket standby
                    className = "badge_standy";
                } else if (statusId == 5) {
                    //tickt chiusi
                    className = "badge_close";
                } else if (statusId == 5) {
                    //tickt cancellati
                    className = "badge_canceled";
                }
                return className;
            };
        });

        //Set correct background for ticket priority
        const prioritaTicket = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == 1) {
                    //ticket aperti
                    className = "badge_low";
                } else if (statusId == 2) {
                    //ticket in lavorazione
                    className = "badge_medium";
                } else if (statusId == 3) {
                    //ticket attesa risposta
                    className = "badge_high";
                }
                return className;
            };
        });

        //Set correct background for intervento status
        const statusIntervento = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == "1") {
                    //lavoro completato
                    className = "badge_low";
                } else {
                    //lavoro non completato
                    className = "badge_high";
                }
                return className;
            };
        });

        /**
         * Open fake modal to view selected ticket attachment
         */
        const selectedImage = ref(null);
        const showImgModal = ref(false);

        function openImgDetail(image) {
            showImgModal.value = true;
            selectedImage.value = setAttachmentUrl(image);
        }

        function closeAttachmentModal() {
            showImgModal.value = false;
        }

        /**
         * Get ticket messages
         */
        const loadingMessages = ref(false);
        const messages = ref([]);
        const loadTicketMessages = async () => {
            loadingMessages.value = true;
            try {
                messages.value = await ticketsAPI.getMessages(ticket.value.tickets_id);
            } catch (error) {
                console.error(error);
                openToast("Errore durante la richiesta dei messaggi", "toast_danger");
            } finally {
                loadingMessages.value = false;
            }
        };

        /**
         * Get related interventi
         */
        const loadInterventi = async () => {
            loading.value = true;
            try {
                interventi.value = await interventiAPI.getInterventi(ticket.value.tickets_id);
            } catch (error) {
                console.error(error);
                openToast("Errore durante la richiesta degli interventi", "toast_danger");
            } finally {
                loading.value = false;
            }
        };

        onMounted(() => {
            loadTicketMessages();
            loadInterventi();
        });

        return {
            loading,
            statoTicket,
            checkField,
            dateFormat,
            dateFormatWithMinutes,
            ticket,
            arrowBackOutline,
            closeModal,
            parseHtmlEnteties,
            prioritaTicket,
            setShortCustomer,
            openNuovoIntervento,
            interventi,
            statusIntervento,
            openInterventoDetail,
            setAttachmentUrl,
            ticketAttachments,
            isImageAttachment,
            getAttachmentName,
            getAttachmentTypeLabel,
            getAttachmentIcon,
            //Attachment modal
            showImgModal,
            selectedImage,
            openImgDetail,
            closeAttachmentModal,
            setAddress,
            contattoCliente,
            telefonoCliente,
            //Messaggi ticket
            loadingMessages,
            messages,
            loggeUserId,
        };
    },
});
</script>

<style scoped>
ion-toolbar {
    --background: #086fa3;
    --color: #ffffff;
}
.loading_spinner {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

ion-item {
    font-size: 14px;
}
ion-label {
    margin: 0;
}

/* New rules */
.page_content {
    width: 100%;
    position: relative; /* to be used for new richiesta btn */
    padding: 16px;
    min-height: 100%;
    background: #f2f2f2;
}

.richiesta {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 16px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 16px;
    /* box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1); */
    box-shadow: 0px 2px 5px 0px #00000040;
}
.richiesta .field {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: .5px solid rgba(118, 118, 128, .24);
}
.richiesta .field:first-child {
    padding-top: 0;
    border-bottom: none;
}
.richiesta .address_field {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}
.richiesta .field_allegati {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 16px 0;
    border-bottom: .5px solid rgba(118, 118, 128, .24);
}
.richiesta .field_note {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 16px 0;
}

.richiesta .address_field .title {
    margin-bottom: 4px;
}
.field .title,
.field_allegati .title,
.field_note .title {
    font-size: 14px;
    font-weight: 500;
    color: #1d1d1b;
}
.field .ticket_title {
    width: 100%;
    text-transform: uppercase;
    text-align: center;
    font-size: 18px;
}
.field_allegati .title,
.field_note .title {
    margin-bottom: 8px;
}
.field .value,
.field_allegati .value,
.field_note .value {
    font-size: 14px;
}

.value .badge {
    font-size: 10px;
    font-weight: 600;
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 4px;
}
.badge {
    font-size: 10px;
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 4px;
}
.badge_close,
.badge_low {
    background-color: rgb(220 252 231);
    color: rgb(34 197 94);
    font-weight: bold;
}
.badge_standy,
.badge_high {
    background-color: rgb(254 226 226);
    color: rgb(239 68 68);
    font-weight: bold;
}
.badge_working,
.badge_medium {
    background-color: rgb(255 237 213);
    color: rgb(249 115 22);
    font-weight: bold;
}
.badge_waiting_answer {
    background-color: rgb(237 233 254);
    color: rgb(139 92 246);
    font-weight: bold;
}
.badge_open {
    background-color: rgb(207 250 254);
    color: rgb(6 182 212);
    font-weight: bold;
}
.badge_canceled {
    background-color: rgb(243 244 246);
    color: rgb(31 41 55);
    font-weight: bold;
}

.nuovo_intervento {
    width: 100%;
    margin-top: 32px;
    padding-bottom: 0;
    display: flex;
    justify-content: center;
}
.intervento_button {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    background-color: #086fa3;
    color: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
    transition: all 0.15s ease-in;
}

/* Elenco interventi */
.interventi_container {
    margin-top: 16px;
}
.interventi_container .interventi_label {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bold;
    color: #475569;
}
.intervento {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: 10px;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
}
.intervento .date {
    font-size: 14px;
    font-weight: 500;
    color: #475569;
}
.intervento .status {
    font-size: 14px;
}

.allegati_container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    overflow-x: scroll;
}
.attachment_card {
    flex: 0 0 auto;
    width: 140px;
}
.attachment_preview {
    width: 140px;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #f8fafc;
    color: #475569;
    text-decoration: none;
    cursor: pointer;
}
button.attachment_preview {
    font-family: inherit;
}
.image_attachment .attachment_preview {
    padding: 0;
    overflow: hidden;
    border: none;
    background: transparent;
}
.image_attachment img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
}
.attachment_preview ion-icon {
    font-size: 40px;
    color: #086fa3;
    margin-bottom: 8px;
}
.attachment_name {
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.attachment_type {
    margin-top: 4px;
    font-size: 10px;
    font-weight: 600;
    color: #64748b;
}

.no_interventi_container {
    width: 100%;
}

.no_interventi {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    margin-bottom: 16px;
    background-color: rgb(226 232 240);
    color: rgb(148 163 184);
    font-size: 16px;
    font-weight: 500;
    border-radius: 4px;
}

/** Modal selected attachment */
.fade-transition-enter-active,
.fade-transition-leave-active {
    transition: opacity 0.25s ease;
}

.fade-transition-enter-from,
.fade-transition-leave-to {
    opacity: 0;
}
.attachment_modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.75);
    color: #ffffff;
    padding: 24px;
    align-items: center;
}
.close_modal {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    color: #ffffff;
    background-color: #086fa3;
    font-size: 16px;
    font-weight: 500;
    border-radius: 20px;
    margin-top: 16px;
}

.mobile_link {
    color: #086fa3;
    text-decoration: none;
}

ion-button {
    --color: #ffffff;
}

/**
* Messaggi ticket
*/
.messages {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 16px;
    background: #ffffff;
    border-radius: 8px;
    margin: 16px 0;
    /* box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1); */
    box-shadow: 0px 2px 5px 0px #00000040;
}
.messages .field {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 6px;
    margin-bottom: 10px;
    border-bottom: .5px solid rgba(118, 118, 128, .24);
}

.messages > .title {
    font-size: 16px;
    font-weight: 500;
    color: #1d1d1b;
}

.messages .messages_container {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
}

.messages .messages_container .message_content {
    width: 90%;
    margin-bottom: 12px;
    font-size: 14px;
    padding: 8px;
    border-radius: 4px;
}

.messages .messages_container .message_content.user_message {
    align-self: end;
    background-color: #086fa3;
    color: #ffffff;
}
.messages .messages_container .message_content.customer_message {
    align-self: start;
    background-color: #f1f5f9;
    color: #475569;
}
.messages .messages_container .message_content .date {
    display: flex;
    justify-content: flex-end;
    font-size: 10px;
    margin-top: 8px;
}
.messages .messages_container .message_content.user_message .date {
    color: #ffffff;
}
.messages .messages_container .message_content.customer_message .date {
    color: #475569;
}
</style>
